import * as React from "react"

export default function SpotifySearchPage(): JSX.Element {
    return (
        <div>
            <h3 style={{ textAlign: "center" }}>Still in construction</h3>
        </div>
    )
}
